var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-cancel-btn",class:{ loading: _vm.isLoading, disabled: _vm.isDisabled }},[_c('div',{staticClass:"modal-cancel-title",on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.isLoading)?_vm._t("default"):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }